import { useAppTranslation } from '@hooks';
import { css } from '@emotion/react';
import { colors, Icon, LayoutContainer, Space, Text } from 'common-components';
import { useParams } from 'react-router';
import { HitType, TaskType } from '@pages/types';
import { memo } from 'react';

import { TTasklineHitNavParams } from '../shared';

import { TaskSidebarTask, HitSidebarTask } from './sidebar';

type SidebarLayoutsTaskProjectPropsType = {
  task: TaskType
  hit: HitType
};

const SidebarLayoutsTaskProjectComponent = ({ task, hit }: SidebarLayoutsTaskProjectPropsType) => {
  const { translate } = useAppTranslation();
  const { view } = useParams<TTasklineHitNavParams>();

  return (
    <LayoutContainer
      css={css`
        border-left: 1px solid ${colors.gray200};
        height: 100%;
        width: 100%;
        background: ${colors.white};

        .ant-collapse .ant-collapse-item {
          padding: 16px 0 !important;
          border-bottom: 1px solid ${colors.gray200} !important;
        }

        .ant-collapse .ant-collapse-header {
          padding: 0 16px !important;
        }

        .ant-collapse .ant-collapse-title {
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          color: ${colors.gray700};
        }
      `}
    >
      <Space
        size={8}
        orientation={'horizontal'}
        style={{ padding: 16, borderBottom: `1px solid ${colors.gray200}` }}
      >
        <Icon color={colors.gray400} icon={'Menu01'} />
        <Text color={colors.gray700} style={{ fontWeight: 500 }}>
          {translate('project.tasklineOverview.sidebar.title')}
        </Text>
      </Space>

      {view === 'hit' && hit && <HitSidebarTask hit={hit} />}
      {view === 'task' && task && <TaskSidebarTask task={task} />}
    </LayoutContainer>
  );
};

const SidebarLayoutsTaskProject = memo(
  SidebarLayoutsTaskProjectComponent,
  (oldProps: SidebarLayoutsTaskProjectPropsType, newProps: SidebarLayoutsTaskProjectPropsType) => {
    return JSON.stringify(oldProps) === JSON.stringify(newProps);
  },
);

export default SidebarLayoutsTaskProject;
